<template>
  <v-container
    id="data-tables"
    tag="section"
    fluid>
    <v-row>
      <v-col cols="12" md="12">
        <base-material-card
          color="primary"
          icon="mdi-eye-outline"
          inline
          class="mx-5 px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              Visualização do relatório: {{ nomeRelatorio }}
            </div>
          </template>
          <v-row>
            <v-col cols="12" class="mt-1">
              <v-alert dense outlined type="info" color="blue" class="mb-0 py-0 px-1">
                Essa tabela exibe no máximo <b>500</b> registros. Caso queira
                visualizar a consulta completa,
                <a href="javascript:void(0)" @click="downloadSpreadSheet($route.params.id)"
                  >clique aqui</a
                >
                para fazer o download da planilha.
              </v-alert>
            </v-col>
            <v-col cols="12" class="mt-1">
              <v-data-table
                multi-sort
                dense
                :headers="headers"
                :items="items"
                :loading="loading"
                :options="{multiSort: false}"
                loading-text="Carregando tabela"
                :headerProps="{
                  sortByText: 'Ordenar Por'
                }"
                :footer-props="{
                  itemsPerPageText: 'Itens por Página',
                  itemsPerPageOptions: [10, 50, 100, 250, 500]
                }"
                no-data-text="Nenhum registro disponível"
                no-results-text="Nenhum registro correspondente encontrado"
                mobile-breakpoint="10"
              >
                <template v-slot:item="row">
                  <tr>
                    <td v-for="(element, i) in row.item" :key="i">
                      {{element | treatDinamic(headers[i].type)}}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RelatoriosService from "@/services/RelatoriosService";
import downloadSpreadSheet from "@/mixins/downloadSpreadSheet";

export default {
  created(){
    this.nomeRelatorio = "...";
    this.loading = false;
    this.headers = [];
    this.items = [];
    this.getDados();
  },

  mixins: [
    downloadSpreadSheet
  ],

  data() {
    return {
      nomeRelatorio: "...",
      loading: false,
      headers: [],
      items: []
    };
  },

  methods: {
    getDados() {
      this.loading = true;

      RelatoriosService.preVisualizarConsulta(this.$route.params.id)
        .then(response => {
          this.nomeRelatorio = response.data.nomeConsulta;

          for (let i = 0; i < response.data.cabecalho.length; i++) {
            let nomeColuna = response.data.cabecalho[i];
            this.headers.push({
              value: String(i),
              text: nomeColuna,
              divider: false,
              type: response.data.arrCamposTiposDados[nomeColuna]
            });
          }

          response.data.dados.forEach(linha => {
            this.items.push(linha);
          });
        })
        .catch(err => {
          this.$toast.error("Erro na visualização do relatório.", "", {position: "topRight"});
          console.error("Erro: ", err);
          this.$router.push({ name: 'Relatórios Histórico' });
        })
        .finally(() => this.loading = false);
    }
  },

  filters: {
    treatDinamic(value, type) {
      if (value && value.trim() == '' || !value) return value;

      switch (type) {
        case 'inteiro':
          return parseInt(value).toLocaleString('pt-BR');
        case 'decimal':
          return parseFloat(value).toLocaleString('pt-BR');
        default:
          return value;
      }
    }
  },
};
</script>

<style>
.v-data-table table thead tr th {
  font-weight: 300;
  font-size: 14.5px;
  margin: 0px 0px;
  padding-left: 8px;
  padding-right: 24px;
}

.v-data-table table tbody tr td {
  font-size: 13px;
}
</style>